import { useAppContext, useAppDispatch } from '../../../providers';
import { useSelectedLocation } from '../../../hooks';

import { SelectLocation } from '../../atoms';
import { Back, Tabs, ActionCards } from '../../molecules';
import { StatusContent } from '../../organisms';

import * as classes from './Request.module.css';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { ACTIVE_TAB } from '../../../providers/AppProvider/types';

const TABS = ['Request', 'Status'];

/**
 * Request page
 */
export const Request = () => {
  const { activeTab } = useAppContext();
  const { selectedLocation } = useSelectedLocation();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  // check for query param to set active tab
  useEffect(() => {
    const view = searchParams.get('view');
    dispatch({ type: ACTIVE_TAB, payload: view && TABS.includes(view) ? view : TABS[0] });
  }, [searchParams, dispatch]);

  return (
    <div className={classes.container}>
      <Back />
      <div className={classes.select}>
        <SelectLocation />
      </div>
      <div className={classes.content}>
        {selectedLocation && (
          <>
            <Tabs tabs={TABS} />
            {activeTab === 'Request' && <ActionCards />}
            {activeTab === 'Status' && <StatusContent />}
          </>
        )}
      </div>
    </div>
  );
};
